<template>
	<v-dialog v-model="dialog" persistent width="90vw" @click:outside="closeModal">
		<v-card class="custom-card pb-120" rounded="0">
			<v-toolbar color="secondary" flat class="white--text">
				<v-toolbar-title class="font-weight-bold">{{ title }}</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon class="white--text" @click="closeModal">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-card-text class="py-1 px-1">
				<div class="google-map" style="width:100%;height:550px; z-index: 0;" id="map" ref="googleMap"></div>
				<div class="legend">
					<span class="legend-item"><span class="light-green"></span> {{ $t("deforestation.newForestArea") }} </span>
					<span class="legend-item"><span class="red"></span> {{ $t("deforestation.deforestedArea") }} </span>
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>
<script>
import { Loader } from '@googlemaps/js-api-loader';
export default {
	async mounted() {
		this.mapOptions.center.lat = this.lat;
		this.mapOptions.center.lng = this.lng;
		try {
			const loader = await new Loader({
				apiKey: "AIzaSyBxEppGyQ3YatmT9C8RJjXAh9HsVtpKLh4",
				libraries: ["places", "map", "geometry"]
			}).load()
				.then((google) => {
					this.google = google;
					this.initializeMap(google);
				})
				.catch(e => {
					console.log('Map', e);
				});
			this.loader = loader;

		} catch (e) {
			console.log(e);
		}
	},
	computed: {
		dialog() {
			return this.dialogU;
		}
	},
	data() {
		return {
			loader: null,
			google: null,
			mapOptions: {
				mapTypeId: 'satellite',
				center: {

				},
				zoom: 18,
			},
			latitude: 0,
			longitude: 0,
		};
	},
	methods: {
		closeModal() {
			this.$emit("dialog-closed");
		},
		getPolygonBounds() {
			console.log(this.polygon)
			var paths = this.polygon.getPaths();
			var bounds = new this.google.maps.LatLngBounds();
			paths.forEach(function (path) {
				var ar = path.getArray();
				for (var i = 0, l = ar.length; i < l; i++) {
					bounds.extend(ar[i]);
				}
			});
			return bounds;
		},
		async initializeMap(google) {
			this.google = google;
			const mapContainer = this.$refs.googleMap
			this.map = await new google.maps.Map(mapContainer, this.mapOptions);
			await this.createPolygon()

			const bounds = this.getPolygonBounds()
			this.map.fitBounds(bounds);
			// console.log(bounds, 'bounds')
			// The photograph is courtesy of the U.S. Geological Survey.
			const srcImage = this.satelliteImage

			// The custom USGSOverlay object contains the USGS image,
			// the bounds of the image, and a reference to the map.
			class USGSOverlay extends google.maps.OverlayView {
				bounds_;
				image_;
				div_;
				constructor(bounds, image) {
					super();
					// Initialize all properties.
					this.bounds_ = bounds;
					this.image_ = image;
					// Define a property to hold the image's div. We'll
					// actually create this div upon receipt of the onAdd()
					// method so we'll leave it null for now.
					this.div_ = null;
				}
				/**
				 * onAdd is called when the map's panes are ready and the overlay has been
				 * added to the map.
				 */
				onAdd() {
					this.div_ = document.createElement("div");
					this.div_.style.borderStyle = "none";
					this.div_.style.borderWidth = "0px";
					this.div_.style.position = "absolute";

					// Create the img element and attach it to the div.
					const img = document.createElement("img");

					img.src = this.image_;
					// console.log(img, 'img')
					img.style.width = "100%";
					img.style.height = "100%";
					img.style.position = "absolute";
					this.div_.appendChild(img);

					// Add the element to the "overlayLayer" pane.
					const panes = this.getPanes();

					panes.overlayLayer.appendChild(this.div_);
				}
				draw() {
					// We use the south-west and north-east
					// coordinates of the overlay to peg it to the correct position and size.
					// To do this, we need to retrieve the projection from the overlay.
					const overlayProjection = this.getProjection();
					// Retrieve the south-west and north-east coordinates of this overlay
					// in LatLngs and convert them to pixel coordinates.
					// We'll use these coordinates to resize the div.
					const sw = overlayProjection.fromLatLngToDivPixel(
						this.bounds_.getSouthWest()
					);
					// console.log(sw, 'sw')
					const ne = overlayProjection.fromLatLngToDivPixel(
						this.bounds_.getNorthEast()
					);
					// console.log(ne, 'ne')

					// Resize the image's div to fit the indicated dimensions.
					if (this.div_) {
						this.div_.style.left = sw.x + "px";
						this.div_.style.top = ne.y + "px";
						this.div_.style.width = ne.x - sw.x + "px";
						this.div_.style.height = sw.y - ne.y + "px";
						// console.log(ne.x - sw.x + "px", 'width')
						// console.log(sw.y - ne.y + "px", 'height')
					}

				}
				/**
				 * The onRemove() method will be called automatically from the API if
				 * we ever set the overlay's map property to 'null'.
				 */
				onRemove() {
					if (this.div_) {
						this.div_.parentNode.removeChild(this.div_);
						this.div_ = null;
					}
				}
			}

			const overlay = new USGSOverlay(bounds, srcImage, this.map);
			// console.log(overlay)

			overlay.setMap(this.map);
		},
		async createPolygon() {
			if (this.polygon != null) this.polygon.setMap(null);
			this.polygon = await new this.google.maps.Polygon({
				paths: this.polygonCoords,
				strokeColor: "transparent",
				// strokeColor: "#1F5D51",
				strokeOpacity: 0.8,
				strokeWeight: 3,
				fillColor: "#E5F8F1",
				fillOpacity: 0,
				editable: false,
				draggable: false,
				icon: this.google.maps.SymbolPath.BACKWARD_CLOSED_ARROW
			});

			this.polygon.setMap(this.map);
			return Promise.resolve(true)

		},
	},
	props: {
		dialogU: {
			type: Boolean,
			required: true,
		},
		polygonCoords: {
			required: true
		},
		lat: {
			required: true
		},
		lng: {
			required: true
		},
		satelliteImage: {
			required: true
		},
		title: {
			required: true
		}
	}
};
</script>

<style>
.legend {
	padding: 16px;
	display: flex;
	align-items: center;
}

.legend-item {
	display: flex;
	margin-right: 20px;
}

.legend-item span {
	width: 20px;
	height: 20px;
	display: inline-block;
	margin-right: 8px;
}

.dark-green {
	background-color: #006837;
}

.light-green {
	background-color: #93d067;
}

.red {
	background-color: #a50026;
}
</style>